import { render } from "./category-requirements.vue?vue&type=template&id=32924c4c&scoped=true&ts=true"
import script from "./category-requirements.vue?vue&type=script&lang=ts"
export * from "./category-requirements.vue?vue&type=script&lang=ts"

import "./category-requirements.vue?vue&type=style&index=0&id=32924c4c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32924c4c"]])

export default __exports__